<template>
  <div class="container thanks">
    <img src="../assets/images/alfy-logo-100.png" alt="Alfy Logo" />
    <h2>¡Listo!</h2>
    <h4>En breve recibirás un email con la confirmación de apertura</h4>
    <button @click="goHome()">Volvé a la página de Alfy</button>
    <h3>Seguinos en nuestras redes</h3>
    <div class="social-icons">
      <ul>
        <li><a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer"><img src="../assets/images/facebook.png" alt="Facebook"></a></li>
        <li><a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"><img src="../assets/images/instagram.png" alt="Instagram"></a></li>
        <li><a href="https://www.twitter.com/" target="_blank" rel="noopener noreferrer"><img src="../assets/images/twitter.png" alt="Twitter"></a></li>
        <li><a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer"><img src="../assets/images/linkedin.png" alt="Linkedin"></a></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'thanks',
  methods: {
    goHome() {
      window.location.href = 'https://www.alfyinversiones.com.ar';
    },
  },
  props: {
    token: String,
    loggedIn: Boolean,
    user: Object,
    userData: Object,
    screen: Number,
  },
  mounted() {
    /* We redirect to log in screen if not logged in */
    if (!this.$props.loggedIn) this.$router.push({ name: 'basic-info' });
    if (this.$props.screen !== 4) this.$emit('advance-screen-protect', this.$props.screen);
    window.gtag('config', 'UA-140392151-1', {
      page_title: 'paso5',
      page_path: '/thanks',
    });
    localStorage.clear();
  },
};
</script>

<style lang="scss">
  .thanks {
    h2 {
      font-size: 24px;
      font-weight: 400;
      margin: 24px 0px;
    }
    h4 {
      line-height: 1.2;
    }
    h3 {
      font-size: 18px;
      font-weight: 600;
      margin-top: 24px;
    }
    .social-icons ul {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
    }
    .social-icons li {
      padding: 15px;
    }
    .social-icons img {
      max-width: 100%;
      height: auto;
    }
    .social-icons a {
      display: block;
    }
  }
</style>
